export default __webpack_public_path__ + "static/media/kids-3.968ce33a.jpeg";